/* THE BAG MARK (P18-4): the count sits on the bag's body by INK, not by its box. For the count it holds, the element draws the
   digits on a canvas at 20 times their size in the page's own face, takes the ink's centre of mass, and moves the SVG text so
   that centre lands on the body's seat (12, 14.5 of the glyph's 24: the body's centre of mass, lifted as the header's bag lifts
   its own). Until the face has loaded the snippet's own seat stands. A changed count rolls: this page's last count is kept for
   the tab, and when the new one differs the old digits leave upward as the new ones arrive from below, inside the body. */
(function () {
  if (customElements.get('svnty-bag-mark')) return;
  var K = 20, CX = 12, CY = 14.5, KEY = 'svnty:bagmark:n', cache = {};   /* the bag's seat and the bag's memory; a sibling mark names its own (data-cx, data-cy, data-key: the wishlist's heart) */
  function centre(text, size, family, weight) {
    var key = [text, size, weight, family].join('|'); if (cache[key]) return cache[key];
    var c = document.createElement('canvas'), w = Math.ceil(size * K * (text.length + 2)), h = Math.ceil(size * K * 2.4);
    c.width = w; c.height = h;
    var g = c.getContext('2d', { willReadFrequently: true }); if (!g) return null;
    g.font = weight + ' ' + (size * K) + 'px ' + family; g.textBaseline = 'alphabetic'; g.textAlign = 'left';
    var ox = size * K, oy = size * K * 1.7;
    g.fillText(text, ox, oy);
    var d = g.getImageData(0, 0, w, h).data, sx = 0, sy = 0, sa = 0;
    for (var y = 0; y < h; y++) for (var x = 0; x < w; x++) { var a = d[(y * w + x) * 4 + 3]; if (a) { sx += a * x; sy += a * y; sa += a; } }
    if (!sa) return null;
    return (cache[key] = { x: (sx / sa + 0.5 - ox) / K, y: (sy / sa + 0.5 - oy) / K });   /* from the text origin on the baseline */
  }
  function seat(t) {
    var text = (t.textContent || '').trim(); if (!text) return;
    var cs = getComputedStyle(t), size = parseFloat(cs.fontSize) || 9.5;
    var m = centre(text, size, cs.fontFamily, cs.fontWeight || '700'); if (!m) return;
    t.style.textAnchor = 'start';
    var host = t.closest('svnty-bag-mark'), cx = host && parseFloat(host.getAttribute('data-cx')), cy = host && parseFloat(host.getAttribute('data-cy'));
    t.setAttribute('x', ((isFinite(cx) ? cx : CX) - m.x).toFixed(3)); t.setAttribute('y', ((isFinite(cy) ? cy : CY) - m.y).toFixed(3));
  }
  function still() { try { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) { return true; } }
  customElements.define('svnty-bag-mark', class extends HTMLElement {
    connectedCallback() {
      var el = this, t = el.querySelector('.svnty-bagmark__n'); if (!t) return;
      var now = (t.textContent || '').trim(), was = null;
      /* a mark the page is not showing (the empty bag's head while the bag holds pieces) takes its seat and stays silent */
      if (!el.getClientRects().length) { seat(t); if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { cache = {}; seat(t); }); return; }
      var key = el.getAttribute('data-key') || KEY;
      try { was = sessionStorage.getItem(key); sessionStorage.setItem(key, now); } catch (e) { was = null; }
      seat(t);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { cache = {}; seat(t); });
      if (was == null || was === now || still() || !t.animate) return;
      var old = t.cloneNode(true); old.textContent = was;
      t.parentNode.insertBefore(old, t);
      old.style.fontSize = was.length >= 3 ? '6.5px' : was.length === 2 ? '8.25px' : '9.5px'; seat(old);
      var o = { duration: 380, easing: 'cubic-bezier(0.2, 0.7, 0.2, 1)', fill: 'both', delay: 260 };
      old.animate([{ transform: 'translateY(0)', opacity: 1 }, { transform: 'translateY(-7px)', opacity: 0 }], o).onfinish = function () { old.remove(); };
      t.animate([{ transform: 'translateY(7px)', opacity: 0 }, { transform: 'translateY(0)', opacity: 1 }], o);
    }
  });
})();
